export default "__VITE_ASSET__BqGAFwZy__"